export const trainTypeImgs = {
	Autobus: new URL("/img/BU.svg", import.meta.url),
	Frecciarossa: new URL("/img/FRECCIAROSSA.svg", import.meta.url),
	'Frecciarossa 1000': new URL("/img/frecciarossa_1000.svg", import.meta.url),
	Frecciargento: new URL("/img/frecciargento.svg", import.meta.url),
	FrecciaBianca: new URL("/img/FB.svg", import.meta.url),
	Intercity: new URL("/img/intercity.svg", import.meta.url),
	InterCityNotte: new URL("/img/intercity_notte.svg", import.meta.url),
	Regionale: new URL("/img/regionale.svg", import.meta.url),
	'Regionale Veloce': new URL("/img/regionale_veloce.svg", import.meta.url),
	'EuroCity': new URL("/img/EC.svg", import.meta.url),
	FrecciaLink: new URL("/img/FL.svg", import.meta.url),
	//Urbano: new URL("/img/WK.svg", import.meta.url), // urbani non sono tutti walk
	Traghetto: new URL("/img/TR.svg", import.meta.url),
	default: new URL("/img/default_logo.svg", import.meta.url),
};

export const trainTypeMap = {
	FR: trainTypeImgs['Frecciarossa'],
	FR1000: trainTypeImgs['Frecciarossa 1000'],	// TODO: CONTROLLARE !
	FA: trainTypeImgs['Frecciargento'],
	IC: trainTypeImgs['Intercity'],
	ICN: trainTypeImgs['InterCityNotte'],
	RE: trainTypeImgs['Regionale'],
	RV: trainTypeImgs['Regionale Veloce'],
	EC: trainTypeImgs['EuroCity']
};

export const styles = {
	prova: 'green',
	thresholds: {
		xs: 0,
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200,
		xxl: 1400,
	}
}